import { searchCountries } from './countries';

const generateRandomString = (length = 10, type = 'all') => {
    const alphabets = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';
    
    let chars = '';
    switch(type) {
        case 'alpha':
            chars = alphabets;
            break;
        case 'alphaUpper':
            chars = alphabets.toUpperCase();
            break;
        case 'numeric':
            chars = numbers;
            break;
        case 'alphanumeric':
            chars = alphabets + numbers;
            break;
        case 'all':
            chars = alphabets + alphabets.toUpperCase() + numbers;
            break;
        case 'complex':
            chars = alphabets + alphabets.toUpperCase() + numbers + symbols;
            break;
        default:
            chars = alphabets + numbers;
    }
    
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

export const generateReferenceNumber = () => {
    const timestamp = Date.now().toString().slice(-6); // Last 6 digits of timestamp
    const random = generateRandomString(4, 'alphanumeric').toUpperCase();
    return `REF-${timestamp}-${random}`;
};

export const generatePassword = () => {
    const timestamp = Date.now().toString().slice(-6); // Last 6 digits of timestamp
    const random = generateRandomString(4, 'alphanumeric').toUpperCase();
    return `PASS-${timestamp}-${random}`;
};

export const countriesList = async (query = null) => {
  return searchCountries(query);
}